var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddSharedMembers = function SvgAddSharedMembers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#C4C4C4",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    x: 2,
    y: 9,
    fill: "#fff",
    rx: 1,
    transform: "rotate(-90 2 9)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    x: 2,
    y: 9,
    fill: "#fff",
    rx: 1,
    transform: "rotate(-90 2 9)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    x: 2,
    y: 9,
    fill: "#fff",
    rx: 1,
    transform: "rotate(-90 2 9)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    x: 2,
    y: 9,
    fill: "#fff",
    rx: 1,
    transform: "rotate(-90 2 9)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    x: 7,
    y: 2,
    fill: "#fff",
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    x: 7,
    y: 2,
    fill: "#fff",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    x: 7,
    y: 2,
    fill: "#fff",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    x: 7,
    y: 2,
    fill: "#fff",
    rx: 1
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddSharedMembers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-shared-members.082d6cb3534cf638d0483b5b6ad45b7e.svg";